// extracted by mini-css-extract-plugin
module.exports =  {"fit-icon":"atCuSzl","fitIcon":"atCuSzl","fit-icon-clickable":"LCF7e7V","fitIconClickable":"LCF7e7V"};